import React, { useRef } from 'react';

import cs from 'classnames';
import { useRecoilValue } from 'recoil';

import DateInputPicker from 'components/shared/DateInputPicker/DateInputPicker';
import { permissions } from 'components/state';

import { surgeriesList } from '../../../../../lib/constants/constants';
import SearchProviders from '../../../../Search/SearchProviders/SearchProviders';
import Select from '../../../Select/Select';
import Textarea from '../../../Textarea/Textarea';
import { isDataReadOnly } from '../lib/aggregatedDataHelper';

const SurgicalHistoryRow = ({
  surgery,
  surgeon,
  date,
  note,
  id,
  forwardedRef,
  onChange,
  newDesign,
  formik,
  className,
  createdBy = null,
  disabled = false
}) => {
  const noteRef = useRef(null);
  const userPermissions = useRecoilValue(permissions);
  const dataReadOnly = isDataReadOnly({
    data: { id, createdBy },
    canUserUpdatePatientDocuments: userPermissions?.form?.update_patient_documents
  });

  return (
    <div className={cs('flex w-full items-center gap-x-[10px]', className)}>
      <div
        className={cs(
          !newDesign ? ' grid w-full grid-cols-3 gap-4' : 'flex w-full flex-col gap-4'
        )}>
        <Select
          inputId="select-surgery"
          label="Surgery"
          placeholder="Type and select surgery"
          options={surgeriesList}
          value={surgery}
          error={formik?.errors?.surgery}
          name="surgery"
          isCreatable
          onChange={(event) => onChange('surgery', event, id)}
          disabled={disabled || dataReadOnly}
        />

        <div className="relative w-full" ref={forwardedRef}>
          <DateInputPicker
            label="Date of surgery"
            isDateOnly
            value={date}
            onChange={(val) => onChange('date', val, id)}
            disabled={disabled || dataReadOnly}
          />
        </div>

        <SearchProviders
          data-qa="type-surgeon"
          label="Surgeon"
          placeholder="Type surgeon"
          value={surgeon}
          onChange={(event) => onChange('surgeon', event, id)}
          disabled={disabled || dataReadOnly}
        />

        <div className={!newDesign && 'col-span-3'}>
          <Textarea
            label="Please notate here if unsure"
            placeholder="Add note here"
            id="note"
            className={cs(!newDesign ? '!min-h-[120px]' : '!min-h-[80px]', 'mb-2  text-sm')}
            isEditor={!newDesign}
            textareaClassName="!min-h-[80px]"
            data-qa="add-note"
            name="note"
            value={note}
            onChange={
              newDesign
                ? (event) => onChange('note', event.target.value, id)
                : (value) => onChange('note', value, id)
            }
            transcribing
            forwardedRef={noteRef}
            disabled={disabled || dataReadOnly}
          />
        </div>
      </div>
    </div>
  );
};

export default SurgicalHistoryRow;
